import { render, staticRenderFns } from "./DataAccess.vue?vue&type=template&id=076f3233&scoped=true"
import script from "./DataAccess.vue?vue&type=script&lang=js"
export * from "./DataAccess.vue?vue&type=script&lang=js"
import style0 from "./DataAccess.vue?vue&type=style&index=0&id=076f3233&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "076f3233",
  null
  
)

export default component.exports